import(/* webpackMode: "eager" */ "/vercel/path0/app/(info)/features/page.tsx");
